import styled from "react-emotion";

export const Perimeter = styled.div`
  overflow: hidden;
  max-height: ${({ theme: { isOpen } }) => (isOpen ? "auto" : 0)};
  transition: max-height 0.3s ease-out;
`;
